import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import FacebookIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/X';

const logoStyle = {
  width: '140px',
  height: 'auto'
};

// function Copyright() {
//   return (
//     <Typography variant="body2" color="text.secondary" mt={1}>
//       {'Copyright © '}
//       <Link href="https://mui.com/">Sitemark&nbsp;</Link>
//       {new Date().getFullYear()}
//     </Typography>
//   );
// }

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        mt: 'auto', // This pushes the footer to the bottom when used in a flex container
        display: 'flex', // Ensure it's always displayed as flex
        flexDirection: 'column'
      }}>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 4, sm: 8 },
          py: { xs: 8, sm: 10 },
          textAlign: { xs: 'center', sm: 'center', md: 'left' }
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            width: '100%',
            justifyContent: 'space-between'
          }}>
          {/* Commented newsletter section */}
          <Box
            sx={{
              display: 'flex', // Always display on all screen sizes
              flexDirection: 'column',
              gap: 1,
              mb: { xs: 2, sm: 0 } // Add margin bottom on mobile
            }}>
            <Typography variant="body2" fontWeight={600}>
              Company
            </Typography>
            <Link color="text.secondary" href="/about-us">
              About us
            </Link>
          </Box>
          <Box
            sx={{
              display: 'flex', // Always display on all screen sizes
              flexDirection: 'column',
              gap: 1
            }}>
            <Typography variant="body2" fontWeight={600}>
              Legal
            </Typography>
            <Link color="text.secondary" href="/terms">
              Terms
            </Link>
            <Link color="text.secondary" href="/privacy">
              Privacy
            </Link>
            <Link color="text.secondary" href="/contact">
              Contact
            </Link>
          </Box>
        </Box>
        {/* <Box
          sx={{
            display: 'flex',
            justifyContent: 'center', // Center on mobile
            pt: { xs: 4, sm: 8 },
            width: '100%',
            borderTop: '1px solid',
            borderColor: 'divider'
          }}>
          <div>
            <Copyright />
          </div>
        </Box> */}
      </Container>
    </Box>
  );
}
